
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"17","height":"16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_12881_14701)","stroke":"#28B7FF","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}},[_c('path',{attrs:{"d":"M1.167 2.667v4h4"}}),_c('path',{attrs:{"d":"M2.84 10a6 6 0 101.42-6.24L1.167 6.667"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_12881_14701"}},[_c('path',{attrs:{"fill":"#fff","transform":"translate(.5)","d":"M0 0h16v16H0z"}})])])])
          )
        }
      }
    